// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	HAMBURGER: '[data-fragment="Header.hamburger"]',
	CLOSE_NAV: '[data-fragment="Header.closeNav"]',
	BACKDROP: '[data-fragment="Header.backdrop"]',
	SEARCH_TRIGGER: '[data-fragment="Header.searchTrigger"]',
	SEARCH_CLOSE: '[data-fragment="Header.closeSearch"]',
	SEARCH_INPUT: '[data-fragment="Header.searchInput"]',
};

export default class Header extends WebComponent {
	constructor(props) {
		super(props);

		this.state = {
			menuOpened: false,
			searchOpened: false,
			headerScrolled: false,
			headerHidden: false,
		};
	}

	didMount() {
		this.on('click', fragments.HAMBURGER, this.openMenu);
		this.on('click', fragments.BACKDROP, this.handleBackdropClick);
		this.on('click', fragments.CLOSE_NAV, this.closeMenu);
		this.on('click', fragments.SEARCH_TRIGGER, this.openSearch);
		this.on('click', fragments.SEARCH_CLOSE, this.closeSearch);
		document.addEventListener('touchstart', this.handleTouchStart, false);
		document.addEventListener('touchmove', this.handleTouchMove, false);
		window.addEventListener('scroll', this.handleScroll);
		this.lastScrollY = 0;
		this.xDown = null;
		this.yDown = null;
		this.searchInput = this.element.querySelector(fragments.SEARCH_INPUT);
	}

	openMenu = () => {
		this.setState({
			menuOpened: true
		});
	};

	closeMenu = () => {
		this.setState({
			menuOpened: false
		});
	};

	openSearch = () => {
		this.searchInput.focus();
		this.setState({
			searchOpened: true
		});
	};

	closeSearch = () => {
		this.setState({
			searchOpened: false
		});
	};

	handleBackdropClick = () => {
		this.closeSearch();
		this.closeMenu();
	}

	handleTouchStart = (e) => {
		const firstTouch = e.touches[0];
		this.xDown = firstTouch.clientX;
		this.yDown = firstTouch.clientY;
	};

	handleTouchMove = (e) => {
		if (!this.xDown || !this.yDown) {
			return;
		}
		const xUp = e.touches[0].clientX;
		const yUp = e.touches[0].clientY;
		const xDiff = this.xDown - xUp;
		const yDiff = this.yDown - yUp;
		if (Math.abs(xDiff) > Math.abs(yDiff)) {
			if (xDiff > 0) {
				this.closeMenu();
			}
		}
		this.xDown = null;
	};

	handleScroll = () => {
		const scrollY = window.scrollY;
		if (window.scrollY > 115) {
			if (scrollY > this.lastScrollY) {
				this.setState({
					headerHidden: true,
				});
			} else {
				this.setState({
					headerHidden: false,
				});
			}
		} else {
			this.setState({
				headerHidden: false,
			});
		}
		this.lastScrollY = scrollY <= 0 ? 0 : scrollY;
	};

	willUnMount() {}
	update() {
		const {
			menuOpened,
			searchOpened,
			headerHidden,
		} = this.state;
		classNames(this.element, { 'header--menu-opened': menuOpened });
		classNames(this.element, { 'header--search-opened': searchOpened });
		if (menuOpened || searchOpened) {
			classNames(document.body, { 'overflow-full': true });
		} else {
			classNames(document.body, { 'overflow-full': false });
		}
		classNames(this.element, { 'header--hidden': headerHidden });
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/Header.js